<template>
	<div class="menu-container">
		<div class="menu-sliders"></div>
		<div class="menu-sliders"></div>
		<div class="menu-sliders"></div>
		<div class="menu">
			<ul>
				<li>
					<router-link to="./" class="link-over"
						>マイウォレット</router-link
					>
				</li>
				<li>
					<router-link to="./deposit2" class="link-over"
						>チャージ</router-link
					>
				</li>
				<li>
					<router-link to="./plan" class="link-over"
						>プラン購入</router-link
					>
				</li>
				<li>
					<router-link to="./history" class="link-over"
						>履歴</router-link
					>
				</li>
				<li>
					<router-link to="./organizationchart" class="link-over"
						>組織</router-link
					>
				</li>
				<li>
					<router-link to="./transfer" class="link-over"
						>転送</router-link
					>
				</li>
				<li>
					<router-link to="./withdraw" class="link-over"
						>出金</router-link
					>
				</li>
				<li>
					<router-link to="/account" class="link-over"
						>アカウント情報</router-link
					>
				</li>
				<li>
					<router-link to="./referral" class="link-over"
						>紹介コード</router-link
					>
				</li>
				<li>
					<router-link to="#" class="link-over"
						>ログアウト</router-link
					>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "HeaderMenu",
	props: {},
	mounted: function () {},
};
</script>

<style scoped lang="less"></style>
